// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#subscriptionpayment-container .accordion-button {
  border-radius: 0px 0px 18px 18px;
}
#subscriptionpayment-container .accordion-button:focus {
  box-shadow: unset;
}
#subscriptionpayment-container .accordion-button:not(.collapsed) {
  background-color: var(--edf0);
  border-radius: unset;
}
#subscriptionpayment-container .accordion-item {
  border-left: unset;
  border-right: unset;
  border-radius: unset;
}
#subscriptionpayment-container .accordion-item:first-child .accordion-button::after {
  display: none;
}
#subscriptionpayment-container .accordion-item:last-child {
  border-bottom: unset;
  border-radius: 0px 0px 18px 18px;
}
#subscriptionpayment-container .cr-block {
  width: 150px;
  text-align: center;
  border: 1px solid var(--dee3);
  border-radius: 4px;
  padding: 6px 0px;
  cursor: pointer;
}
#subscriptionpayment-container .active {
  color: var(--2749);
  background: rgba(108, 86, 255, 0.1);
  border-color: rgba(108, 86, 255, 0.1);
}
#subscriptionpayment-container .button-container-superfluid {
  display: flex;
  height: -moz-fit-content;
  height: fit-content;
}
#subscriptionpayment-container .button-container-superfluid .btn-block {
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
  outline: none;
  border-radius: 10px;
  padding: 0px 20px;
  background-color: var(--56ff);
  color: var(--ffff);
  border: 1px solid var(--ffff);
  min-height: 46px;
}
#subscriptionpayment-container .button-container-superfluid .btn-block:disabled {
  opacity: 0.7;
}
#subscriptionpayment-container .separator-vertical {
  border-right: 1px solid var(--dee3);
  height: 233px;
  position: absolute;
  top: 0px;
}
#subscriptionpayment-container .containerBorder {
  border-top: none !important;
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 14px;
  width: 100%;
}
#subscriptionpayment-container .nowPaymentBtnSelect {
  pointer-events: none;
  opacity: 0.4;
}
#subscriptionpayment-container .Inactive {
  opacity: 0.4;
  pointer-events: none;
}
#subscriptionpayment-container .progress {
  border-radius: 0px !important;
}
#subscriptionpayment-container .progress .progress-bar {
  background-color: var(--56ff);
}
#subscriptionpayment-container .fade-in-animation {
  animation: fadeIn 1s ease-in-out;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
#subscriptionpayment-container input[type=radio] {
  width: 20px;
  height: 20px;
}
#subscriptionpayment-container .radio-input {
  transition: transform 0.3s ease-in-out;
}
#subscriptionpayment-container .radio-input:checked {
  transform: scale(1.2);
  visibility: hidden;
}
#subscriptionpayment-container .borderPayment {
  border-left: 4px solid rgb(108, 86, 255) !important;
}
#subscriptionpayment-container .borderPaymentDark {
  border-left: 4px solid rgb(13, 255, 0) !important;
}
#subscriptionpayment-container .paymentBox {
  border: 1px solid var(--dee3);
  border-radius: 14px;
  padding: 40px;
  padding-left: 30px;
}
#subscriptionpayment-container .paymentBox-dark {
  background-color: #3888ff;
  opacity: 1;
  background-image: linear-gradient(rgba(2, 4, 30, 0.24), rgba(2, 4, 30, 0.24)), linear-gradient(248deg, #ae00ff, #297fff);
  padding: 0.1rem;
  border-radius: 14px;
}
#subscriptionpayment-container .paymentBox-dark .payment-dark {
  background-color: #02041e;
  border-radius: 14px;
  padding: 40px;
  padding-left: 30px;
}
#subscriptionpayment-container .paymentMethod-darkOutline {
  background-color: #3888ff;
  opacity: 1;
  background-image: linear-gradient(rgba(2, 4, 30, 0.24), rgba(2, 4, 30, 0.24)), linear-gradient(248deg, #297fff, #ae00ff);
  padding: 0.1rem;
}
#subscriptionpayment-container .paymentMethod-darkOutline .paymentMethod-dark {
  background-color: rgba(7, 9, 36, 0.9529411765);
  background-image: linear-gradient(rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.03));
}
#subscriptionpayment-container .paymentMethod-darkOutline .paymentMethod-dark:hover {
  background-image: linear-gradient(rgba(255, 255, 255, 0.09), rgba(255, 255, 255, 0.09));
}
#subscriptionpayment-container .nowPayment-dark {
  background-color: #3888ff;
  opacity: 1;
  background-image: linear-gradient(rgba(2, 4, 30, 0.24), rgba(2, 4, 30, 0.24)), linear-gradient(248deg, #297fff, #ae00ff);
  padding: 0.1rem;
}
#subscriptionpayment-container .nowPayment-dark .nowPayment-darkBox {
  background-color: rgba(7, 9, 36, 0.9529411765);
  background-image: linear-gradient(rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.03));
  border-radius: 14px;
  padding: 10px;
}
#subscriptionpayment-container .nowPayment-dark .nowPayment-darkBox:hover {
  background-image: linear-gradient(rgba(255, 255, 255, 0.09), rgba(255, 255, 255, 0.09));
}
#subscriptionpayment-container .superPayment-dark {
  background-color: #3888ff;
  opacity: 1;
  background-image: linear-gradient(rgba(2, 4, 30, 0.24), rgba(2, 4, 30, 0.24)), linear-gradient(248deg, #297fff, #ae00ff);
  padding: 0.1rem;
}
#subscriptionpayment-container .superPayment-dark .superPayment-darkBox {
  background-color: rgba(7, 9, 36, 0.9529411765);
  background-image: linear-gradient(rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.03));
  border-radius: 14px;
  padding: 10px;
}
#subscriptionpayment-container .superPayment-dark .superPayment-darkBox:hover {
  background-image: linear-gradient(rgba(255, 255, 255, 0.09), rgba(255, 255, 255, 0.09));
}`, "",{"version":3,"sources":["webpack://./src/pages/SubscriptionPayment/SubscriptionPayment.scss"],"names":[],"mappings":"AACE;EACE,gCAAA;AAAJ;AACI;EACE,iBAAA;AACN;AAEE;EACE,6BAAA;EACA,oBAAA;AAAJ;AAEE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;AAAJ;AAEM;EACE,aAAA;AAAR;AAGI;EACE,oBAAA;EACA,gCAAA;AADN;AAIE;EACE,YAAA;EACA,kBAAA;EACA,6BAAA;EAEA,kBAAA;EACA,gBAAA;EACA,eAAA;AAHJ;AAKE;EACE,kBAAA;EACA,mCAAA;EACA,qCAAA;AAHJ;AAKE;EACE,aAAA;EACA,wBAAA;EAAA,mBAAA;AAHJ;AAII;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,6BAAA;EACA,kBAAA;EACA,6BAAA;EACA,gBAAA;AAFN;AAGM;EACE,YAAA;AADR;AAKE;EACE,mCAAA;EACA,aAAA;EACA,kBAAA;EACA,QAAA;AAHJ;AAKE;EACE,2BAAA;EACA,+BAAA;EACA,gCAAA;EACA,WAAA;AAHJ;AAKE;EACE,oBAAA;EACA,YAAA;AAHJ;AAKE;EACE,YAAA;EACA,oBAAA;AAHJ;AAME;EACE,6BAAA;AAJJ;AAKI;EACE,6BAAA;AAHN;AAOE;EACE,gCAAA;AALJ;AAQE;EACE;IACE,UAAA;EANJ;EAQE;IACE,UAAA;EANJ;AACF;AASE;EACE,WAAA;EACA,YAAA;AAPJ;AASE;EACE,sCAAA;AAPJ;AASE;EACE,qBAAA;EACA,kBAAA;AAPJ;AASE;EACE,mDAAA;AAPJ;AASE;EACE,iDAAA;AAPJ;AASE;EACE,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAPJ;AASE;EACE,yBAAA;EACA,UAAA;EACA,wHAAA;EAKA,eAAA;EACA,mBAAA;AAXJ;AAYI;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAVN;AAaE;EACE,yBAAA;EACA,UAAA;EACA,wHAAA;EAKA,eAAA;AAfJ;AAgBI;EACE,8CAAA;EACA,uFAAA;AAdN;AAmBI;EACE,uFAAA;AAjBN;AAuBE;EACE,yBAAA;EACA,UAAA;EACA,wHAAA;EAKA,eAAA;AAzBJ;AA0BI;EACE,8CAAA;EACA,uFAAA;EAIA,mBAAA;EACA,aAAA;AA3BN;AA6BI;EACE,uFAAA;AA3BN;AAiCE;EACE,yBAAA;EACA,UAAA;EACA,wHAAA;EAKA,eAAA;AAnCJ;AAoCI;EACE,8CAAA;EACA,uFAAA;EAIA,mBAAA;EACA,aAAA;AArCN;AAuCI;EACE,uFAAA;AArCN","sourcesContent":["#subscriptionpayment-container {\r\n  .accordion-button {\r\n    border-radius: 0px 0px 18px 18px;\r\n    &:focus {\r\n      box-shadow: unset;\r\n    }\r\n  }\r\n  .accordion-button:not(.collapsed) {\r\n    background-color: var(--edf0);\r\n    border-radius: unset;\r\n  }\r\n  .accordion-item {\r\n    border-left: unset;\r\n    border-right: unset;\r\n    border-radius: unset;\r\n    &:first-child {\r\n      .accordion-button::after {\r\n        display: none;\r\n      }\r\n    }\r\n    &:last-child {\r\n      border-bottom: unset;\r\n      border-radius: 0px 0px 18px 18px;\r\n    }\r\n  }\r\n  .cr-block {\r\n    width: 150px;\r\n    text-align: center;\r\n    border: 1px solid var(--dee3);\r\n    // background-color: var(--dee3);\r\n    border-radius: 4px;\r\n    padding: 6px 0px;\r\n    cursor: pointer;\r\n  }\r\n  .active {\r\n    color: var(--2749);\r\n    background: rgba(108, 86, 255, 0.1);\r\n    border-color: rgba(108, 86, 255, 0.1);\r\n  }\r\n  .button-container-superfluid {\r\n    display: flex;\r\n    height: fit-content;\r\n    .btn-block {\r\n      font-size: 16px;\r\n      font-weight: 600;\r\n      line-height: 19px;\r\n      outline: none;\r\n      border-radius: 10px;\r\n      padding: 0px 20px;\r\n      background-color: var(--56ff);\r\n      color: var(--ffff);\r\n      border: 1px solid var(--ffff);\r\n      min-height: 46px;\r\n      &:disabled {\r\n        opacity: 0.7;\r\n      }\r\n    }\r\n  }\r\n  .separator-vertical {\r\n    border-right: 1px solid var(--dee3);\r\n    height: 233px;\r\n    position: absolute;\r\n    top: 0px;\r\n  }\r\n  .containerBorder {\r\n    border-top: none !important;\r\n    border-bottom-left-radius: 14px;\r\n    border-bottom-right-radius: 14px;\r\n    width: 100%;\r\n  }\r\n  .nowPaymentBtnSelect {\r\n    pointer-events: none;\r\n    opacity: 0.4;\r\n  }\r\n  .Inactive {\r\n    opacity: 0.4;\r\n    pointer-events: none;\r\n  }\r\n\r\n  .progress {\r\n    border-radius: 0px !important;\r\n    .progress-bar {\r\n      background-color: var(--56ff);\r\n    }\r\n  }\r\n\r\n  .fade-in-animation {\r\n    animation: fadeIn 1s ease-in-out;\r\n  }\r\n\r\n  @keyframes fadeIn {\r\n    from {\r\n      opacity: 0;\r\n    }\r\n    to {\r\n      opacity: 1;\r\n    }\r\n  }\r\n\r\n  input[type=\"radio\"] {\r\n    width: 20px;\r\n    height: 20px;\r\n  }\r\n  .radio-input {\r\n    transition: transform 0.3s ease-in-out;\r\n  }\r\n  .radio-input:checked {\r\n    transform: scale(1.2);\r\n    visibility: hidden;\r\n  }\r\n  .borderPayment {\r\n    border-left: 4px solid rgb(108, 86, 255) !important;\r\n  }\r\n  .borderPaymentDark {\r\n    border-left: 4px solid rgb(13 255 0) !important;\r\n  }\r\n  .paymentBox {\r\n    border: 1px solid var(--dee3);\r\n    border-radius: 14px;\r\n    padding: 40px;\r\n    padding-left: 30px;\r\n  }\r\n  .paymentBox-dark {\r\n    background-color: #3888ff;\r\n    opacity: 1;\r\n    background-image: linear-gradient(\r\n        rgba(2, 4, 30, 0.24),\r\n        rgba(2, 4, 30, 0.24)\r\n      ),\r\n      linear-gradient(248deg, #ae00ff, #297fff);\r\n    padding: 0.1rem;\r\n    border-radius: 14px;\r\n    .payment-dark {\r\n      background-color: #02041e;\r\n      border-radius: 14px;\r\n      padding: 40px;\r\n      padding-left: 30px;\r\n    }\r\n  }\r\n  .paymentMethod-darkOutline {\r\n    background-color: #3888ff;\r\n    opacity: 1;\r\n    background-image: linear-gradient(\r\n        rgba(2, 4, 30, 0.24),\r\n        rgba(2, 4, 30, 0.24)\r\n      ),\r\n      linear-gradient(248deg, #297fff, #ae00ff);\r\n    padding: 0.1rem;\r\n    .paymentMethod-dark {\r\n      background-color: #070924f3;\r\n      background-image: linear-gradient(\r\n        rgba(255, 255, 255, 0.03),\r\n        rgba(255, 255, 255, 0.03)\r\n      );\r\n    }\r\n    .paymentMethod-dark:hover {\r\n      background-image: linear-gradient(\r\n        rgba(255, 255, 255, 0.09),\r\n        rgba(255, 255, 255, 0.09)\r\n      );\r\n    }\r\n  }\r\n  .nowPayment-dark {\r\n    background-color: #3888ff;\r\n    opacity: 1;\r\n    background-image: linear-gradient(\r\n        rgba(2, 4, 30, 0.24),\r\n        rgba(2, 4, 30, 0.24)\r\n      ),\r\n      linear-gradient(248deg, #297fff, #ae00ff);\r\n    padding: 0.1rem;\r\n    .nowPayment-darkBox {\r\n      background-color: #070924f3;\r\n      background-image: linear-gradient(\r\n        rgba(255, 255, 255, 0.03),\r\n        rgba(255, 255, 255, 0.03)\r\n      );\r\n      border-radius: 14px;\r\n      padding: 10px;\r\n    }\r\n    .nowPayment-darkBox:hover {\r\n      background-image: linear-gradient(\r\n        rgba(255, 255, 255, 0.09),\r\n        rgba(255, 255, 255, 0.09)\r\n      );\r\n    }\r\n  }\r\n  .superPayment-dark {\r\n    background-color: #3888ff;\r\n    opacity: 1;\r\n    background-image: linear-gradient(\r\n        rgba(2, 4, 30, 0.24),\r\n        rgba(2, 4, 30, 0.24)\r\n      ),\r\n      linear-gradient(248deg, #297fff, #ae00ff);\r\n    padding: 0.1rem;\r\n    .superPayment-darkBox {\r\n      background-color: #070924f3;\r\n      background-image: linear-gradient(\r\n        rgba(255, 255, 255, 0.03),\r\n        rgba(255, 255, 255, 0.03)\r\n      );\r\n      border-radius: 14px;\r\n      padding: 10px;\r\n    }\r\n    .superPayment-darkBox:hover {\r\n      background-image: linear-gradient(\r\n        rgba(255, 255, 255, 0.09),\r\n        rgba(255, 255, 255, 0.09)\r\n      );\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
